// frontend/src/screens/AddPostScreen.js
import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { createPost } from "../actions/postActions";
import { POST_CREATE_RESET } from "../constants/postConstants";
import { fetchProjectDetails } from "../actions/projectActions";

const AddPostScreen = () => {
  const { projectId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Form fields
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [videoURL, setVideoURL] = useState("");
  const [modelURL, setModelURL] = useState("");
  const [walkthroughURL, setWalkthroughURL] = useState("");
  const [snapshots, setSnapshots] = useState([]);

  // Pull from Redux store
  const postCreate = useSelector((state) => state.postCreate);
  // Replace `success` with `postCreateSuccess`
  const { loading, error, postCreateSuccess, post } = postCreate;

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    const postData = {
      title,
      description,
      videoURL,
      modelURL,
      walkthroughURL,
      snapshots,
      project: projectId,
    };
    dispatch(createPost(postData));
  };

  // Handle adding snapshots via prompt
  const handleAddSnapshot = () => {
    const url = prompt("Enter snapshot image URL:");
    if (url) {
      setSnapshots((prev) => [...prev, url]);
    }
  };

  // Watch for postCreateSuccess
  useEffect(() => {
    if (postCreateSuccess) {
      // Re-fetch the project
      dispatch(fetchProjectDetails(projectId));
      // Navigate back
      navigate(`/posts/${projectId}`);
      // Reset create slice
      dispatch({ type: POST_CREATE_RESET });
      // Clear local form
      setTitle("");
      setDescription("");
      setVideoURL("");
      setModelURL("");
      setWalkthroughURL("");
      setSnapshots([]);
    }
  }, [postCreateSuccess, dispatch, navigate, projectId]);

  return (
    <div>
      <h2>Create New Post for Project ID: {projectId}</h2>
      {error && <p style={{ color: "red" }}>{error}</p>}
      {loading && <p>Loading...</p>}

      <form onSubmit={handleSubmit}>
        <div>
          <label>Title:</label>
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
          />
        </div>

        <div>
          <label>Description:</label>
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            required
          />
        </div>

        <div>
          <label>Video URL:</label>
          <input
            type="text"
            value={videoURL}
            onChange={(e) => setVideoURL(e.target.value)}
          />
        </div>

        <div>
          <label>3D Model URL:</label>
          <input
            type="text"
            value={modelURL}
            onChange={(e) => setModelURL(e.target.value)}
          />
        </div>

        <div>
          <label>360 Walkthrough URL:</label>
          <input
            type="text"
            value={walkthroughURL}
            onChange={(e) => setWalkthroughURL(e.target.value)}
          />
        </div>

        <div>
          <label>Snapshots:</label>
          <ul>
            {snapshots.map((snap, idx) => (
              <li key={idx}>{snap}</li>
            ))}
          </ul>
          <button type="button" onClick={handleAddSnapshot}>
            Add Snapshot
          </button>
        </div>

        <button type="submit">Create Post</button>
      </form>
    </div>
  );
};

export default AddPostScreen;
